import { BrickDefinitionRemoteDto } from '../../../../../generated/signalR/brick-definition-remote-dto';
import { IBrickInstanceTargetingAction } from '../../../utility/IBrickInstanceTargetingAction';
import { BrickInstance } from '../brick-wall.state';
import { BrickLayoutType } from '../../../../samwebDescription/samweb/dashboard/brickLayoutType';
import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { LongRunningAction } from 'src/app/store/server-communication/running-actions/types/longRunningAction.decorator';

export class StartBrickEditing {
   public static readonly type = '[Brick Wall] Start brick editing';
}

@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class StopBrickEditing {
   public static readonly type = '[Brick Wall] Stop brick editing';

   constructor(public saveChanges: boolean) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class SaveBrickWallChanges {
   public static readonly type = '[Brick Wall Actions] Save Brick Wall Changes With Brick Settings';
}

export class StartEditingBrickSettings {
   public static readonly type = '[Brick Wall Actions] Start Editing Brick Settings';

   constructor() {}
}

export class StopEditingBrickSettings {
   public static readonly type = '[Brick Wall Actions] Stop Editing Brick Settings';

   constructor() {}
}

export class BrickWallInstancesChangedAction {
   public static readonly type = '[Brick Wall] Instances Changed';

   constructor(public instances: BrickInstance[]) {}
}

export class BrickItemChangedOnWallAction {
   public static readonly type = '[Brick Wall] Items changed';

   constructor(public instanceId: string, public gridsterInstance: any, public brickLayout: BrickLayoutType) {}
}

export class BrickWallChangedByServerAction {
   public static readonly type = '[Brick Wall] BrickWallChangedByServer';

   constructor(public bricks: BrickDefinitionRemoteDto[]) {}
}

export class AddNewBrickToWallAction {
   public static readonly type = '[Brick Wall] Add new Brick to wall';

   constructor(public brickDefinitionId: string, public brickLayout: BrickLayoutType, public responsibleLayoutBrick?: string) {}
}

export class LayoutBrickAddedToWall {
   public static readonly type = '[Brick Wall] LayoutBrickAddedToWall';

   constructor(public newBrickInstanceId: string, public responsibleLayoutBrickInstanceId: string) {}
}

export class RemoveBrickFromWall implements IBrickInstanceTargetingAction {
   public static readonly type = '[Brick Wall] Remove brick from wall';

   constructor(public brickInstanceId: string) {}
}
